/**
 * Store access/refresh tokens in localStorage when backend returns them in the response body.
 * Used as fallback when cookies are not sent cross-origin (e.g. run.cards -> runcards-production).
 * localStorage persists across tab close and refresh so users stay logged in.
 * Both apiService and consoleApiService send Authorization: Bearer when accessToken is present.
 */
const ACCESS_TOKEN_KEY = 'runcards_access_token';
const REFRESH_TOKEN_KEY = 'runcards_refresh_token';

export function setTokens(accessToken, refreshToken) {
  if (typeof window === 'undefined') return;
  const a = accessToken && String(accessToken).trim();
  const r = refreshToken && String(refreshToken).trim();
  if (a) localStorage.setItem(ACCESS_TOKEN_KEY, a);
  if (r) localStorage.setItem(REFRESH_TOKEN_KEY, r);
}

export function getAccessToken() {
  if (typeof window === 'undefined') return null;
  const t = localStorage.getItem(ACCESS_TOKEN_KEY);
  return t && t.trim() ? t : null;
}

export function getRefreshToken() {
  if (typeof window === 'undefined') return null;
  const t = localStorage.getItem(REFRESH_TOKEN_KEY);
  return t && t.trim() ? t : null;
}

export function clearTokens() {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}
